// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Responsive = require("./reason/helpers/Responsive.bs.js");

var AgentInfo;

var Avatar;

var Buttons;

var Card;

var Dialog;

var BaseDialog;

var FormV5;

var Heading;

var HighlightSection;

var Icon;

var InlineWarning;

var List;

var Loader;

var PaginationBox;

var PaymentForm;

var Responsive$1;

var $$Text;

var TextLabel;

var TipBox;

var TogglesGroup;

var VerifiedAgentCard;

var View;

var WarningSection;

var ContentBox;

var Chat;

var Touchable;

var VerticalCard;

var IconCallout;

var HorizontalDivider;

var responsive = Responsive.make;

exports.AgentInfo = AgentInfo;
exports.Avatar = Avatar;
exports.Buttons = Buttons;
exports.Card = Card;
exports.Dialog = Dialog;
exports.BaseDialog = BaseDialog;
exports.FormV5 = FormV5;
exports.Heading = Heading;
exports.HighlightSection = HighlightSection;
exports.Icon = Icon;
exports.InlineWarning = InlineWarning;
exports.List = List;
exports.Loader = Loader;
exports.PaginationBox = PaginationBox;
exports.PaymentForm = PaymentForm;
exports.Responsive = Responsive$1;
exports.$$Text = $$Text;
exports.TextLabel = TextLabel;
exports.TipBox = TipBox;
exports.TogglesGroup = TogglesGroup;
exports.VerifiedAgentCard = VerifiedAgentCard;
exports.View = View;
exports.WarningSection = WarningSection;
exports.ContentBox = ContentBox;
exports.Chat = Chat;
exports.Touchable = Touchable;
exports.VerticalCard = VerticalCard;
exports.IconCallout = IconCallout;
exports.HorizontalDivider = HorizontalDivider;
exports.responsive = responsive;
/* No side effect */
